var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header__top_account_dotsbutton"},[_c('component-button-menu',{attrs:{"name":'header-top-account-dots-button',"icon":true,"icon-name":'more-vertical',"icon-raw":true,"theme":'',"menu-style":'second',"buttons":[
            {
                key: 'what-new',
                name: "What's new",
                icon: true,
                iconName: 'external-link',
                iconAlign: 'right'
            }
        ]},on:{"emit-what-new":_vm.redirectToWhatNew}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }